import { api } from '../lib/api';
import type { AuthUser, UpdateProfileInput } from '@gwc/shared';

export const authApi = {
  updateProfile: (body: UpdateProfileInput) =>
    api.patch<{ user: AuthUser }>('/auth/me', body).then((r) => r.user),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post<{ ok: true }>('/auth/change-password', { currentPassword, newPassword }),
  forgotPassword: (email: string) => api.post<{ ok: true }>('/auth/forgot-password', { email }),
  resetPassword: (token: string, password: string) =>
    api.post<{ ok: true }>('/auth/reset-password', { token, password }),
};
